import React from 'react';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import MenuList, {MenuListProps} from '@mui/material/MenuList';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import {useMenu} from './useMenu';

type MenuProps = {
   name: React.ReactNode;
   children: React.ReactNode;
   hideExpandIcon?: boolean;
   disabled?: boolean;
   hoverable?: boolean;
   id?: string;
   classes?: {root?: string; paper?: string};
};

// const useStyles = makeStyles((theme: Theme) => ({
//    root: {
//       display: 'flex',
//       height: '100%',
//       '& button': {
//          height: '100%',
//          borderRadius: 0,
//       },
//    },
//    paper: {
//       maxHeight: '85vh',
//       overflowY: 'auto',
//       overflowX: 'visible',
//       marginTop: theme.spacing(1),
//       '& .MuiList-padding': {
//          padding: 0,
//       },
//    },
//    anchor: {
//       textTransform: 'none',
//    },
// }));

const Menu = ({name, children, hideExpandIcon, disabled, id, hoverable, classes}: MenuProps) => {
   // const classes = {} as any; // useStyles();
   const {
      open,
      anchorRef,
      handleToggle,
      handleOpen,
      handleClose,
      handleListKeyDown,
   } = useMenu<HTMLButtonElement>();

   return (
      <div className={classes?.root}>
         <div
            onMouseLeave={hoverable ? handleClose : undefined}
            // onBlur={hoverable ? handleClose : undefined}
         >
            <Button
               id={id}
               // className={classes?.anchor}
               ref={anchorRef}
               aria-controls={open ? 'menu-list-grow' : undefined}
               aria-haspopup="true"
               onClick={hoverable ? undefined : handleToggle}
               onMouseEnter={hoverable ? handleOpen : undefined}
               // onFocus={hoverable ? handleOpen : undefined}
               disabled={disabled}
            >
               {name} {!hideExpandIcon && <ExpandMoreRoundedIcon />}
            </Button>
            <Popper
               open={open}
               anchorEl={anchorRef.current}
               placement="bottom-start"
               role={undefined}
               transition
               disablePortal
               sx={{
                  zIndex: '99',
               }}
            >
               {({TransitionProps}) => (
                  <Grow
                     {...TransitionProps}
                     style={{
                        transformOrigin: 'top',
                     }}
                  >
                     <Paper classes={{root: classes?.paper}} elevation={5}>
                        <ClickAwayListener onClickAway={handleClose}>
                           <MenuList
                              autoFocusItem={open}
                              variant="menu"
                              id="menu-list-grow"
                              onKeyDown={handleListKeyDown}
                           >
                              {children}
                           </MenuList>
                        </ClickAwayListener>
                     </Paper>
                  </Grow>
               )}
            </Popper>
         </div>
      </div>
   );
};

export default Menu;
